import createCrudVuexModule from "@/store/crud";

export const libraryControlType = createCrudVuexModule({
  namespaced: true,
  path: "/library/control-type",
  moduleName: "libraryControlType",
  options: {
    localizedFields: ["name"],
  },
});

export const managementLibraryControlType = createCrudVuexModule({
  namespaced: true,
  path: "/management/library/control-type",
  moduleName: "managementLibraryControlType",
  options: {
    localizedFields: ["name"],
  },
});

export const workspaceLibraryControlType = createCrudVuexModule({
  namespaced: true,
  path: "/workspace/library/control-type",
  moduleName: "workspaceLibraryControlType",
  options: {
    localizedFields: ["name"],
  },
});

export const libraryControlCategory = createCrudVuexModule({
  namespaced: true,
  path: "/library/control-category",
  moduleName: "libraryControlCategory",
  options: {
    localizedFields: ["name"],
  },
});

export const managementLibraryControlCategory = createCrudVuexModule({
  namespaced: true,
  path: "/management/library/control-category",
  moduleName: "managementLibraryControlCategory",
  options: {
    localizedFields: ["name"],
  },
});

export const workspaceLibraryControlCategory = createCrudVuexModule({
  namespaced: true,
  path: "/workspace/library/control-category",
  moduleName: "workspaceLibraryControlCategory",
  options: {
    localizedFields: ["name"],
  },
});
